const ALLOWED_KEYS = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

export const isValidNumberKeyDown = (key: string): boolean => {
  const isDigit = /^[0-9]$/.test(key);
  const isComma = key === ',';
  return isDigit || isComma || ALLOWED_KEYS.includes(key);
};
